import './Info.css';

export default function Info() {
    return (

        <section className="infoSection">
            <div>
                <h2>
                    Stay ahead with reflections, product discoveries, and short-form updates.
                </h2>
                <div className="heroActions">
                    <a href="https://www.facebook.com/explorelrt" className="primaryButton">View Updates</a>
                    <a href="/about" className="secondaryButton">About this site</a>
                </div>
            </div>
        </section>

    );
}
